import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useRouter, useStore } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import SidebarFooter from '@/components/global/SidebarFooter/SidebarFooter.vue';
import EditIcon from '@/assets/svg/edit-action.vue.svg';
import WarRoomCommissionEarnBanner from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBanner.vue';
import WarRoomMobileAppBannerAside from '@/components/partials/war-room/WarRoomMobileAppBanner/WarRoomMobileAppBannerAside/WarRoomMobileAppBannerAside.vue';
import WarRoomRules from '@/components/partials/war-room/WarRoomRules.vue';
import WarRoomTopics from '@/components/partials/war-room/WarRoomTopics.vue';
import WarRoomProfileBanner from '@/components/partials/war-room/WarRoomProfileBanner/WarRoomProfileBanner.vue';
import type { RootState } from '~/types/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostListSidebar',
  setup(__props) {

const { $analytics } = useContext();
const router = useRouter();
const store = useStore<RootState>();

const popular_topics = computed(() => store.state.warRoom.popular_topics);

function handleCreatePostClick() {
  $analytics?.logEvent('war-room__create-a-post-button__click');
  router.push({ name: 'war-room-posts-new' });
}

return { __sfc: true,$analytics, router, store, popular_topics, handleCreatePostClick, BravadoButtonV3, SidebarFooter, EditIcon, WarRoomCommissionEarnBanner, WarRoomMobileAppBannerAside, WarRoomRules, WarRoomTopics, WarRoomProfileBanner }
}

})